import { DI_CONTAINER_TYPE as DI_CONTAINER_TYPE_DEFAULT } from '@edikk-edikk/country-frontend';

const DI_CONTAINER_TYPE = {
  ...DI_CONTAINER_TYPE_DEFAULT,
};

export { DI_CONTAINER_TYPE };
